import Vue from 'vue';

// When the request succeeds
const success = (response, context) => {
  $(".cancel").removeClass("disabled");
  $(".confirm").removeClass("disabled");
  swal("Added!", "Your imaginary user has been added as team member!", "success");
  context.loading = false;
  Vue.router.push({
    name: 'account.team'
  });
};

// When the request fails
const failed = (error, context) => {
    toastr.error(error);
    context.loading = false;
};

export default (member, rights, context) => {
  return Vue.$http.post('/team-members/attach-team-member', {
      member: member,
      rights: rights
  })
    .then((response) => {
      if (response && response.status === 200) {
        success(response, context);
      } else {
        failed();
      }
    })
    .catch((error) => {
      failed(error, context);
    });
};



// WEBPACK FOOTER //
// ./src/app/services/team_member/attachTeamMember.js